import { Role } from '../../../../shared/enums/role.enum';
import { NavItemI } from '../../../../shared/interfaces/nav-item.interface';

export const SIDE_MENU_ITEMS: NavItemI[] = [
  {
    translationPath: 'sideMenu.faculties',
    activeIcon: 'svgs/side-menu/active-faculty.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-faculty.svg',
    route: ['faculties'],
    alt: 'Faculties',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.OBSERVER],
  },
  {
    translationPath: 'sideMenu.departments',
    activeIcon: 'svgs/side-menu/active-departments.svg',
    nonActiveIcon: 'svgs/side-menu/inactive-departments.svg',
    route: ['departments'],
    alt: 'Departments',
    roles: [Role.SUPER_ADMIN, Role.ADMIN, Role.DEAN, Role.OBSERVER],
  },
  {
    translationPath: 'sideMenu.programs',
    activeIcon: 'svgs/side-menu/active-program.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-program.svg',
    route: ['programs'],
    alt: 'Programs',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.DEPARTMENT_MANAGER,
      Role.OBSERVER,
    ],
  },
  {
    translationPath: 'sideMenu.courses',
    activeIcon: 'svgs/side-menu/active-course.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-course.svg',
    route: ['courses'],
    alt: 'Courses',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.DEPARTMENT_MANAGER,
      Role.PROGRAM_MANAGER,
      Role.OBSERVER,
    ],
  },
  {
    translationPath: 'sideMenu.instructors',
    activeIcon: 'svgs/side-menu/active-instructor.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-instructor.svg',
    route: ['instructors'],
    alt: 'Instructors',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.DEPARTMENT_MANAGER,
      Role.PROGRAM_MANAGER,
      Role.COORDINATOR,
      Role.OBSERVER,
    ],
  },
  {
    translationPath: 'sideMenu.students',
    activeIcon: 'svgs/side-menu/active-student.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-student.svg',
    route: ['students'],
    alt: 'Students',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.DEPARTMENT_MANAGER,
      Role.PROGRAM_MANAGER,
      Role.COORDINATOR,
      Role.INSTRUCTOR,
      Role.OBSERVER,
    ],
  },
  {
    translationPath: 'sideMenu.courseSections',
    activeIcon: 'svgs/side-menu/active-course-sections.svg',
    nonActiveIcon: 'svgs/side-menu/inactive-course-sections.svg',
    route: ['course-sections'],
    alt: 'Course Sections',
    roles: [
      Role.SUPER_ADMIN,
      Role.ADMIN,
      Role.DEAN,
      Role.DEPARTMENT_MANAGER,
      Role.PROGRAM_MANAGER,
      Role.COORDINATOR,
      Role.INSTRUCTOR,
      Role.OBSERVER,
    ],
  },
];
